import React from 'react';
import { Box } from '@mui/material';

const ImageContent = ({ item, index, isMobile }) => {
    //console.log("ImageContent item:", item, "index:", index, "isMobile:", isMobile);
    return (
        <Box key={index} sx={{ marginBottom: item.marginBottom || '16px' }}>
            <img
                className="game-section-image"
                style={{
                    display: 'block',
                    margin: '0 auto',
                    width: isMobile ? (item.mobileWidth || '95%') : (item.desktopWidth || '95%'),
                    maxWidth: item.maxWidth || '400px',
                    height: 'auto',
                }}
                src={item.src}
                alt={item.alt || ''}
            />
        </Box>
    );
};

export default ImageContent;